<div kalDialogContent
     [kalLoading]="loading"
     [formGroup]="form" class="activityOverpaiymentDialog">

    <div class="container">

        <kal-form-field>
            <kal-select formControlName="overpaymentBankAccount"
                        id="activity_overpayment_dialog_bank_account"
                        label="Compte d'enregistrement du trop perçu">
                <kal-option *ngFor="let account of overpaymentAccountsList"
                            [value]="account.Id">
                    {{account.Numero}} - {{account.Libelle}}
                </kal-option>
            </kal-select>
        </kal-form-field>

        <div class="gup-O-separationLine"></div>

        <kal-form-field class="without-label">
            <ng-template kalFormFieldLabel="Gestion du trop Perçu"></ng-template>
            <kal-radio-group formControlName="policy"
                             label="Gestion du trop Perçu">
                <kal-radio value="extraordinaryProduct"
                           id="activity_overpayment_dialog_radio_extraordinary_product">
                    Enregistrer un produit exceptionnel
                </kal-radio>
                <kal-radio value="refund"
                           id="activity_overpayment_dialog_radio_refund">
                    Rembourser le bénéficiaire
                </kal-radio>
            </kal-radio-group>
        </kal-form-field>

        <ng-container *ngIf="isRefund; else extraordinaryProduct">
            <ng-container *ngTemplateOutlet="refund"></ng-container>
        </ng-container>


        <!-- REMBOURSEMENT BENEFICIAIRE -->
        <ng-template #refund>
            <div formGroupName="refund">

                <div class="gup-C-flexGroup -row -justifyBetween -alignCenter">

                    <!-- Moyen de paiement -->
                    <div class="gup-C-flexGroup__item -demi">

                        <kal-form-field>

                            <kal-select formControlName="paymentMethodId"
                                        id="activity_overpayment_dialog_payment_method"
                                        label="Moyen de remboursement">

                                <kal-option *ngFor="let paymentMethod of paymentMethodsList"
                                            [value]="paymentMethod.Id">
                                    {{ paymentMethod.Libelle }}
                                </kal-option>

                            </kal-select>

                        </kal-form-field>

                    </div>

                    <!-- Date -->
                    <div class="gup-C-flexGroup__item -demi">
                        <kal-form-field>

                            <kal-input formControlName="refundDate"
                                       id="activity_overpayment_dialog_date"
                                       label="Date du remboursement">
                            </kal-input>

                        </kal-form-field>
                    </div>

                </div>

                <ng-container *ngIf="selectedPaymentMethod">

                    <!-- Spécifique chèque bancaire -->
                    <ng-container *ngIf="shouldDisplayCheque">

                        <div class="gup-C-flexGroup -row -justifyBetween -alignCenter">

                            <!-- Numéro de chèque -->
                            <div class="gup-C-flexGroup__item -demi">
                                <kal-form-field>

                                    <kal-input formControlName="chequeNumber"
                                               id="activity_overpayment_dialog_cheque_number"
                                               label="Numéro du chèque">
                                    </kal-input>

                                </kal-form-field>
                            </div>
                        </div>

                        <div class="gup-C-flexGroup -row -justifyBetween -alignCenter">

                            <!-- Banque -->
                            <div class="gup-C-flexGroup__item -demi">

                                <kal-form-field>

                                    <kal-select formControlName="bankName"
                                                id="activity_overpayment_dialog_bank"
                                                label="Banque">

                                        <kal-option *ngFor="let bank of bankList"
                                                    [value]="bank">
                                            {{ bank }}
                                        </kal-option>

                                    </kal-select>

                                </kal-form-field>

                            </div>

                            <!-- Nom tiré -->
                            <div class="gup-C-flexGroup__item -demi">
                                <kal-form-field>

                                    <kal-input formControlName="tiretName"
                                               id="activity_overpayment_tire"
                                               label="Nom tiré">
                                    </kal-input>

                                </kal-form-field>
                            </div>

                        </div>

                    </ng-container>

                    <!-- Spécifique PMV -->
                    <ng-container *ngIf="shouldDisplayPmvAccount">

                        <div class="gup-C-flexGroup -row -justifyBetween -alignStart">

                            <!-- Compte collectif -->
                            <div class="gup-C-flexGroup__item -demi">

                                <kal-form-field>

                                    <kal-select formControlName="collectiveAccountId"
                                                id="activity_overpayment_dialog_collective_account"
                                                label="Compte bancaire">

                                        <kal-option *ngFor="let collectiveAccount of collectivePMVAccountsList"
                                                    [value]="collectiveAccount.Id">
                                            {{ collectiveAccount.Numero }} - {{ collectiveAccount.Libelle }}
                                        </kal-option>

                                    </kal-select>

                                </kal-form-field>

                            </div>

                        </div>

                    </ng-container>

                    <div class="gup-C-flexGroup -row -justifyBetween -alignCenter">

                        <!-- Compte bancaire -->
                        <div *ngIf="shouldDisplayBankAccount"
                             class="gup-C-flexGroup__item -demi">

                            <kal-form-field>

                                <kal-select formControlName="bankAccountId"
                                            id="activity_overpayment_dialog_refund_bank_account"
                                            label="Compte bancaire">

                                    <kal-option *ngFor="let bankAccount of bankAccountsList"
                                                [value]="bankAccount.Id">
                                        {{ bankAccount.Libelle }}
                                    </kal-option>

                                </kal-select>

                            </kal-form-field>

                        </div>

                        <!-- Journal -->
                        <div class="gup-C-flexGroup__item -demi">

                            <kal-form-field>

                                <kal-select formControlName="journalRefund"
                                            id="activity_overpayment_dialog_journal"
                                            label="Journal">

                                    <kal-option *ngFor="let journal of refundJournals"
                                                [value]="journal.Id">
                                        {{ journal.Libelle }}
                                    </kal-option>

                                </kal-select>

                            </kal-form-field>

                        </div>

                    </div>
                </ng-container>
            </div>
        </ng-template>

        <!-- PRODUIT EXTRAORDINAIRE -->
        <ng-template #extraordinaryProduct>
            <div formGroupName="extraordinaryProduct">

                <kal-form-field>
                    <kal-select label="Imputation"
                                formControlName="account"
                                id="activity_overpayment_dialog_account">

                        <kal-option *ngFor="let account of accounts"
                                    [value]="account.Id">
                            {{account.Numero}} - {{account.Libelle}}
                        </kal-option>
                    </kal-select>

                    <kal-checkbox formControlName="displayAllAccounts"
                                  label="Voir tous les comptes"
                                  id="activity_overpayment_dialog_account_display_all">
                    </kal-checkbox>
                </kal-form-field>

                <kal-form-field>
                    <kal-select label="Journal"
                                id="activity_overpayment_dialog_extraordinary_product_journal"
                                formControlName="journalExtra">
                        <kal-option *ngFor="let journal of productJournals" [value]="journal.Id">
                            {{journal.Libelle}}
                        </kal-option>
                    </kal-select>
                </kal-form-field>

                <app-analytical-plan-distributer formControlName="distribution">
                </app-analytical-plan-distributer>

            </div>

        </ng-template>
    </div>

</div>

<div kalDialogFooter>

    <div class="gup-C-validationArea gup-O-list">

        <div class="gup-O-list__item">

            <kal-button id="activity_overpaid_dialog_submit"
                        kalTheme="primary"
                        [disabled]="form.invalid || loading"
                        (click)="submit()">
                Valider
            </kal-button>

        </div>

        <div class="gup-O-list__item">

            <kal-button id="activity_overpayment_dialog_cancel"
                        kalTheme="secondary"
                        [disabled]="loading"
                        (click)="close()">
                Fermer et revenir au règlement
            </kal-button>

        </div>

    </div>
</div>

